module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/read-more/read-more.component.scss
// module id = ./src/app/shared-components/read-more/read-more.component.scss
// module chunks = main